import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { compose, withPropsOnChange, withHandlers } from 'recompose';
import { buildSearchLink } from 'lib/search';
import { scrollTo } from 'lib/helpers';
import { 
	parseAmenityFromPath, 
	parseVehicleFromPath,
	getFilterParamForAmenity,
	parseSizeFromPath
} from 'lib/search/parseAmenityFromPath';

import NewPagination from 'components/core/Pagination/NewPagination';
import { omit } from 'lodash';

export const enhance = compose(
	withHandlers({
		handlePageChange: () => () => scrollTo(0),
	}),
	withPropsOnChange(
		['numPages', 'searchParams'],
		({ numPages, searchParams, searchPath }) => {
			// Always omit these params from pagination links
			const paramsToOmit = [
				'latitude',
				'longitude',
				'subPageType',
				'listingsPerPage',
			];

			let paginatedParams = searchParams?.page 
				? omit(searchParams, paramsToOmit)
				: searchParams;

			const isNearMePath = searchPath && searchPath.startsWith('/near-me/');

			if (!isNearMePath) {
				const amenityFromPath = parseAmenityFromPath(searchPath);
				if (amenityFromPath) {
					const filterParam = getFilterParamForAmenity(amenityFromPath);
					const paramsToRemove = ['amenity'];
					if (filterParam) {
						paramsToRemove.push(filterParam);
					}
					paginatedParams = omit(paginatedParams, paramsToRemove);
				}

				const vehicleFromPath = parseVehicleFromPath(searchPath);
				if (vehicleFromPath) {
					paginatedParams = omit(paginatedParams, ['vehicle', 'searchType']);
				}

				const sizeFromPath = parseSizeFromPath(searchPath);
				if (sizeFromPath) {
					paginatedParams = omit(paginatedParams, ['sqft']);
				}
			}

			const pagesObject = {
				pages: range(0, numPages).map((index) => ({
					to: buildSearchLink(
						{ ...paginatedParams, page: index + 1 },
						searchPath
					),
					nofollow: false,
					pageNumber: index + 1,
				})),
			};

			return pagesObject;
		}
	)
);

export function SearchPagination({ pages, selectedPage, handlePageChange }) {
	return (
		<div className="search-pagination">
			<NewPagination
				pages={pages}
				selectedPage={selectedPage}
				onPageChange={handlePageChange}
			/>
		</div>
	);
}

SearchPagination.propTypes = {
	pages: PropTypes.arrayOf(
		PropTypes.shape({
			link: PropTypes.string,
		})
	),
	selectedPage: PropTypes.number,
	handlePageChange: PropTypes.func,
};

export default enhance(SearchPagination);
